import { useSelector } from 'react-redux';
import { selectPublisherInfo } from 'modules/settings/store/selectors';

export const usePublisher = () => {
  const publisher = useSelector(selectPublisherInfo);

  return publisher;
};
